import { Component, Input, OnInit } from '@angular/core'
import { AccountInfo } from '@se-po/shared-data-access-models'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

@Component({
  selector: 'se-po-parent-contact-info',
  templateUrl: './parent-contact-info.component.html',
  styleUrls: ['./parent-contact-info.component.scss'],
  standalone: false,
})
export class ParentContactInfoComponent implements OnInit {
  @Input() public persona: Persona | AccountInfo
  public primaryEmailDisplay: string
  public primaryPhoneDisplay: string

  public ngOnInit(): void {
    this.primaryEmailDisplay = 'email' in this.persona ? this.persona?.email : this.persona?.email_addresses?.[0]?.address
    this.primaryPhoneDisplay = 'phone' in this.persona ? this.persona?.phone : this.persona?.phone_numbers?.[0]?.number
  }
}
